import React from 'react';

export default function TermsPage() {
  return (
    <main data-testid="terms-page" className="pt-20 min-h-screen bg-[#F6F3EE]">
      <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#C6A978] mb-6">
            Legal
          </p>

          <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light tracking-tighter text-[#1E1C1A] mb-4">
            Terms of Service
          </h1>

          <p className="text-sm font-light text-[#7A7369] mb-12">
            Last updated: May 2025
          </p>

          <div className="space-y-10 text-sm font-light leading-relaxed tracking-wide text-[#7A7369]">

            {/* 1 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                1. General Terms
              </h2>

              <p>
                By accessing or using the KIRAQ website and placing orders via
                WhatsApp or any other channel, you agree to be bound by these
                Terms of Service. These terms govern all visitors, customers,
                and users of our services.
              </p>
            </div>

            {/* 2 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                2. Products & Materials
              </h2>

              <p className="mb-3">
                All KIRAQ jewellery is crafted from{" "}
                <strong className="text-[#3A3632] font-medium">
                  premium gold-finish stainless steel
                </strong>.
              </p>

              <ul className="space-y-2 list-none pl-4 border-l-2 border-[#C6A978]/40">
                <li>
                  All pieces are made from anti-tarnish stainless steel with a
                  gold finish.
                </li>

                <li>
                  Avoid prolonged exposure to water, perfumes, sweat, and harsh
                  chemicals to maintain longevity.
                </li>

                <li>
                  Product images are as accurate as possible, however slight
                  variations in colour may occur due to lighting and screens.
                </li>

                <li>
                  Each product is described as accurately as possible. KIRAQ is
                  not responsible for dissatisfaction arising from material
                  misinterpretation.
                </li>
              </ul>
            </div>

            {/* 3 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                3. Orders & Payments
              </h2>

              <p className="mb-3">
                All orders at KIRAQ are placed via{" "}
                <strong className="text-[#3A3632] font-medium">
                  WhatsApp
                </strong>.
              </p>

              <ul className="space-y-2 list-none pl-4 border-l-2 border-[#C6A978]/40">
                <li>
                  Orders are confirmed only upon receipt of full payment.
                </li>

                <li>
                  Prices are listed in Indian Rupees (INR) inclusive of
                  applicable taxes.
                </li>

                <li>
                  We accept UPI, bank transfer, and selected payment methods
                  communicated during order confirmation.
                </li>

                <li>
                  Payment confirmation and order details are shared via
                  WhatsApp.
                </li>
              </ul>
            </div>

            {/* 4 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                4. Returns & Exchanges
              </h2>

              <p className="mb-3">
                We offer a{" "}
                <strong className="text-[#3A3632] font-medium">
                  7-day return window
                </strong>{" "}
                from the date of delivery.
              </p>

              <ul className="space-y-2 list-none pl-4 border-l-2 border-[#C6A978]/40">
                <li>
                  Items must be unworn, unaltered, and returned in original
                  packaging.
                </li>

                <li>
                  Contact us via WhatsApp within 7 days to initiate a return.
                </li>

                <li>
                  Return shipping costs are borne by the customer unless the
                  item was defective or incorrect.
                </li>

                <li>
                  Refunds are processed within 5–7 business days after
                  inspection.
                </li>

                <li>
                  Customised pieces and worn items are not eligible for return.
                </li>

                <li>
                  We strongly recommend recording an unboxing video for
                  damage-related claims.
                </li>
              </ul>
            </div>

            {/* 5 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                5. Shipping & Delivery
              </h2>

              <ul className="space-y-2 list-none pl-4 border-l-2 border-[#C6A978]/40">
                <li>
                  Orders are dispatched within 2–3 business days after payment
                  confirmation.
                </li>

                <li>
                  Every order is shipped in our signature KIRAQ packaging.
                </li>

                <li>
                  Free shipping is available on eligible orders above ₹499.
                </li>

                <li>
                  Tracking details are shared via WhatsApp after dispatch.
                </li>

                <li>
                  KIRAQ is not responsible for courier delays or incorrect
                  delivery details provided by customers.
                </li>
              </ul>
            </div>

            {/* 6 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                6. Product Availability
              </h2>

              <p>
                KIRAQ operates on a limited-edition model. Certain pieces may
                not be restocked once sold out. We reserve the right to cancel
                orders for unavailable products with a full refund issued
                promptly.
              </p>
            </div>

            {/* 7 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                7. Intellectual Property
              </h2>

              <p>
                All content on this website — including text, images, product
                names, branding, and designs — is the exclusive property of
                KIRAQ and protected by applicable intellectual property laws.
              </p>
            </div>

            {/* 8 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                8. Limitation of Liability
              </h2>

              <p>
                KIRAQ shall not be held liable for indirect, incidental, or
                consequential damages arising from the use of our products or
                services. Our liability is limited to the original purchase
                price of the item concerned.
              </p>
            </div>

            {/* 9 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                9. Privacy
              </h2>

              <p>
                We collect only the information necessary to process your orders
                and provide customer support. We do not sell or share your
                personal information with third parties.
              </p>
            </div>

            {/* 10 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                10. Governing Law
              </h2>

              <p>
                These terms are governed by the laws of India. Any disputes
                arising from the use of KIRAQ services shall fall under the
                jurisdiction of courts in Punjab, India.
              </p>
            </div>

            {/* 11 */}
            <div>
              <h2 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#1E1C1A] mb-4">
                11. Contact
              </h2>

              <ul className="space-y-1.5 list-none pl-4 border-l-2 border-[#C6A978]/40">
                <li>Email: kiraqindia@gmail.com</li>
                <li>WhatsApp: Available via the website chat button</li>
                <li>Response time: Within 24 hours on business days</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
}